import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,Label, Input, Container, Button, Alert } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import toastr from "toastr";
import { TOAST_OPTIONS, HRConfig } from "helpers/backend_helper";
import "toastr/build/toastr.min.css";

    const SetServer = () => {

        const [serverSet, setServerSet] = useState(JSON.parse(localStorage.getItem("MM_SET")));

        toastr.options = TOAST_OPTIONS;
        //'http://41.190.146.254:6012/'
        //http://neptune.uga.hrpsolutions.com:6012/

        const submit = () => {
            const bcAddress = document.getElementsByClassName("bcAdd")[0].value
            const apAddress = document.getElementsByClassName("apAdd")[0].value
            const bcUN = document.getElementsByClassName("bcUsername")[0].value
            const bcPS = document.getElementsByClassName("bcPassword")[0].value
            const data = {bc: bcAddress, ap: apAddress, us: bcUN, ps: bcPS}
            
            localStorage.setItem("MM_SET", JSON.stringify(data))
        
            setServerSet(data)
           
            toastr.success("Server setup details saved...")
        }
        useEffect(() => {
            setServerSet(localStorage.getItem("BC_SET"))
        },[]);

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Setup | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>

                        <div>
                        <Row>
                        <Col xl={12}>
                        <Card>
                            <CardBody>
                            <CardTitle>&nbsp;</CardTitle>
                                    <Row>
                                    <Col md={5}>
                                    <div className="row mb-4">
                                                <Label
                                                    htmlFor="horizontal-email-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                     BC Server
                                                </Label>
                                                <Col sm={9}>
                                                <Input
                                                    type="text"
                                                    className="form-control bcAdd"
                                                    defaultValue={serverSet && serverSet.bc}
                                                    />
                                                
                                                </Col>
                                                </div>
                                    </Col>
                                    <Col md={5}>
                                    <div className="row mb-4">
                                                <Label
                                                    htmlFor="horizontal-email-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                     Apache Server
                                                </Label>
                                                <Col sm={9}>
                                                <Input
                                                    type="text"
                                                    className="form-control apAdd"
                                                    defaultValue={serverSet && serverSet.ap}
                                                    />
                                                
                                                </Col>
                                                </div>
                                    </Col>
                                    
                                </Row>
                                <Row>
                                <Col md={5}>
                                    <div className="row mb-4">
                                                <Label
                                                    htmlFor="horizontal-email-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                     BC Username
                                                </Label>
                                                <Col sm={9}>
                                                <Input
                                                    type="text"
                                                    className="form-control bcUsername"
                                                    defaultValue={serverSet && serverSet.us}
                                                    />
                                                
                                                </Col>
                                                </div>
                                    </Col>
                                    <Col md={5}>
                                    <div className="row mb-4">
                                                <Label
                                                    htmlFor="horizontal-email-Input"
                                                    className="col-sm-3 col-form-label"
                                                >
                                                     BC Password
                                                </Label>
                                                <Col sm={9}>
                                                <Input
                                                    type="text"
                                                    className="form-control bcPassword"
                                                    defaultValue={serverSet && serverSet.ps}
                                                    />
                                                
                                                </Col>
                                                </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn " onClick={submit}>
                                                Save
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                        </div>
                    </Container>
                </div>
         
            </>
        );
    }

export default SetServer;